import React from "react";

import { FullScreenLoader } from "components/Loader";
import { SuperuserFeature } from "components/privilegedUserFeatures";
import { useAnswerContext } from "contexts/answerContext";
import useRegisteredHotKey from "hooks/useRegisteredHotKey";
import { useFillAnswers } from "queries/admin/projects";

const useGenerateAnswers = () => {
  const { dispatch, record: project } = useAnswerContext();
  const { mutateAsync: generateAnswers } = useFillAnswers(project.id, {
    onSuccess: (updatedProject) => {
      dispatch({ type: "update", record: updatedProject });
    },
  });
  return generateAnswers;
};

const AnswerGeneratorOverlay = () => <FullScreenLoader label="Generating Answers" />;
const ProjectHotKeys = () => {
  const {
    context: { identifier: context },
  } = useAnswerContext();
  const generateAnswers = useGenerateAnswers();

  useRegisteredHotKey(
    "g",
    ({ event, setOverlay, close }) => {
      event.preventDefault();
      setOverlay(AnswerGeneratorOverlay);
      generateAnswers({ context }, { onSuccess: close });
    },
    {
      section: "Project",
      description: "Generate Answers",
      dependencies: [context],
    },
  );

  return null;
};

const MaybeProjectHotKeys = () => (
  <SuperuserFeature>
    <ProjectHotKeys />
  </SuperuserFeature>
);

export default MaybeProjectHotKeys;
